module.exports = __webpack_public_path__ + "img/5618965.570aa94f.png";